import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const areas = [
  {
    tag: "Macro Area 1",
    title: "Gestione d'impresa, fiscale e commerciale",
    topics: [
      "Avvio attività e forme giuridiche: Partita IVA, codici ATECO, Ditta Individuale, SNC, SAS, SRL",
      "Registro Imprese ed enti: CCIAA, INPS, INAIL, SCIA e pratiche SUAP",
      "Contabilità e fiscalità: fatture, corrispettivi, IVA, costi, ricavi e margini",
      "Contratti commerciali, gestione fornitori e tutela del consumatore",
      "Trasparenza dei prezzi e disciplina della somministrazione di alimenti e bevande",
      "Sicurezza sul lavoro, responsabilità e obblighi dell'esercente",
    ],
  },
  {
    tag: "Macro Area 2",
    title: "Merceologia, igiene e sicurezza alimentare",
    topics: [
      "Categorie alimentari, temperature, catena del freddo e stoccaggio",
      "Rischio microbiologico e prevenzione delle contaminazioni crociate",
      "Autocontrollo HACCP, igiene personale e sanificazione di locali e attrezzature",
      "Etichettatura, scadenze e tracciabilità di filiera",
      "Gestione di allergeni, additivi e materiali a contatto (MOCA)",
      "Normativa igienico-sanitaria e tutela della salute pubblica",
    ],
  },
];

export default function Programma() {
  return (
    <section id="programma" className="border-t border-line bg-paper py-16 md:py-24" data-testid="programma-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Programma didattico · 130 ore"
          title="Cosa imparerai durante il corso"
          sub="Un percorso completo e abilitante, dalla gestione fiscale dell'attività alla sicurezza alimentare, conforme alla disciplina di Regione Lombardia."
          testid="programma"
        />
        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:col-span-8">
            {areas.map((area, ai) => (
              <Reveal key={area.tag} delay={ai * 0.12}>
                <div className="h-full border border-line bg-white p-7" data-testid={`programma-area-${ai + 1}`}>
                  <span className="inline-block bg-brand-light px-3 py-1 font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-amber-800">
                    {area.tag}
                  </span>
                  <h3 className="mt-4 font-heading text-xl font-bold tracking-tight text-navy">{area.title}</h3>
                  <ul className="mt-5 space-y-3">
                    {area.topics.map((t) => (
                      <li key={t} className="flex gap-2.5 text-sm leading-relaxed text-slate-600">
                        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand-amber" />
                        <span>{t}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15} className="lg:col-span-4">
            <div className="relative h-full min-h-[320px] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0cmFpbmluZyUyMGNsYXNzcm9vbSUyMGVkdWNhdGlvbiUyMGFkdWx0fGVufDB8fHx8MTc4OTU0Mzg3NXww&ixlib=rb-4.1.0&q=85"
                alt="Aula di formazione professionale ANAS Milano"
                className="absolute inset-0 h-full w-full object-cover"
                data-testid="programma-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/90 via-navy-deep/20 to-transparent" />
              <div className="absolute bottom-0 p-6 text-white">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-brand-amber">Esame finale abilitante</p>
                <p className="mt-2 font-heading text-xl font-bold leading-snug">
                  Al termine delle 130 ore, davanti alla Commissione d'esame di Regione Lombardia
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
